import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import CustomTableGrid from 'components/uiComponents/CustomTableGrid';
import DispalyImage from 'components/wrapperComponents/DispalyImage';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { msgTypes } from 'constants/msgTypes';
import { Form, Formik } from 'formik';
import { BlogModel } from 'model/screensModels/BlogModel';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { ResponseModel } from 'model/utilModels/ResponseModel';
import { useEffect, useMemo, useState } from 'react';
import { BlogSchema } from 'schemas/menu/blog/BlogSchema';
import { BlogService } from 'services/menu/blogService/BlogService';
import { conformationAlert } from 'services/shared/alert';


const BlogList = ({ setFlag, updateRecord, loadRecentBlog }) => {

  const [blogList, setBlogList] =  useState<ResponseModel | null>(null); 
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  })

  const columns = useMemo(() =>
    [
     
      {
        accessorKey: "title",
        header: "Title",
        size: 150
      },
      {
        accessorKey: "shortDescription",
        header: "Short Description",
        size: 200
      },
   {
  header: "Description",
  accessorKey: "description",
  Cell: ({ row }) => (
<div
      className="ql-editor"
      style={{
        maxHeight: '150px',
        overflow: 'auto',
        padding: 0
      }}
      dangerouslySetInnerHTML={{
        __html: row.original.description || ""
      }}
    />
  ),
  size: 300
},
      {
        header: 'Image',
        Cell: ({ renderedCellValue, row }) => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            < DispalyImage
                  imageUrl={row.original?.image}
                  imageSize={msgTypes.IMAGE_SIZE.SMALL} />
          </Box>
        ),
        size: 50
      },
      {
        header: 'Action',
        Cell: ({ renderedCellValue, row }) => (
          <div className='d-flex'>
            <Tooltip title="Edit">
              <EditIcon fontSize="small" onClick={() => { editRecord(row.original) }} />
            </Tooltip>
            <Tooltip title="Delete">
              <DeleteIcon fontSize="small" onClick={() => { deleteRecord(row.original) }} />
            </Tooltip>
          </div>
        ),
        size: 10,
        grow: false,
      },

    ], []);

  // //Begin:: UseEffect Hooks 

  useEffect(() => {
    getBlogList();
  }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])

  //End:: UseEffect Hooks 


  //Prepare request body to get blog list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    return requestBody;
  }

  //Get Blog list
  const getBlogList = async () => {
    const requestBody = prepareRequest();
    const res = await BlogService.getBlogList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setBlogList(res);
      //setBlogList(undefined)
    }
  }




  //Open Form To edit Record
  const editRecord = (record: BlogModel) => {
    updateRecord(record);
    setFlag(true)
  }

  const deleteRecord = async (record: BlogModel) => {
    const requestData: BlogModel = new BlogModel();
    requestData.blogId = record.blogId

    const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");

    if (deleteFlag) {
      const res = await BlogService.deleteBlog(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getBlogList();
        loadRecentBlog();
      }
    }
  }


  const initialValues = {}
  const onSubmit = () => {
    getBlogList();
  }



  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={BlogSchema}
      onSubmit={onSubmit}
    >
      {
        formik =>
        (
          <Form>
              {blogList ? (
            <CustomTableGrid
              item={
                <FormikControl
                  control='materialTable'
                  tableColumn={columns}
                  tableData={blogList}
                  setPagination={setPagination}
                />
              }
            />
          ) : null}
          </Form>
        )
      }
    </Formik>
  )
}
export default BlogList;
